module.exports = __webpack_public_path__ + "static/media/Yorktown-By-Laws.135afb08.pdf";